<!-- eslint-disable vue/no-unused-components -->
<!--

  V 0.4.0 - 2026-04-28
      -

   V 0.3.5 - Removed pulsin throbber.
      -

   V 0.3.3 - 2026-03-02
      - Added a timer to the click event on the marker, this is because when clicking on the marker, the click event
        was immediatly triggering the navigator button on the marker when clicked on a mobile device

   V 0.3.2 - 2026-02-23
      - Changed direction icon, and
      - Added auto pop up when Trip Buttons are clicked so user can see

   V 0.2.0 - 2026-02-16
      - Renamed from MapFollow, to VehicleTrack, as this seems mpore in line with the
        way the Maybe keep it as follow Follow Vehicle

   V 0.1.0 - 2026-02-11

  Relevant notes from old version which I modified and upgraded
  to use font icons and use new google maps advanced markers

   V 0.3.1 - 2023-03-08
      - The time was not switching off so this need to be
        change and clearInterval() cassed on  beforeDestroy()

NOTES:
   - In order to test change the below parameter to true;
      //----------------------------------------------------------------------
      // Setting this to truw will provide or create dummy data for the
      // testing the operation of the page
      //----------------------------------------------------------------------
      test: false

-->
<template>
  <v-container>

    <div id="map" :style="mapStyle"></div>

    <v-row>
      <v-col cols="auto">
        <v-progress-circular v-show="isLoading"
                             class="progress-overlay"
                             indeterminate
                             size="120"
                             width="15"
                             color="primary" />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="auto">

        <!-- New 3-dot menu for interval selection -->
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn style="
                    background-color: #2196f3;
                    z-index: 1 !important;
                    top: 14px; left: 208px; height: 32px !important;
                    position: absolute; border-radius: 2px;
                    padding: 3px; color: #fff; "
                   icon
                   v-bind="attrs"
                   v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item v-for="(item, index) in items"
                         :key="index">
              <v-list-item-action>
                <v-checkbox v-model="selected"
                            :value="item.value"
                            hide-details />
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>

        </v-menu>

      </v-col>
    </v-row>

  </v-container>
</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-multiple-empty-lines */

import { differenceInHours, parseISO, addSeconds, formatISO } from 'date-fns'


function getFormattedDateTime () {
  const now = new Date()

  const year = now.getFullYear()
  // getMonth() is zero-based (0 for January), so add 1
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')

  const hours = String(now.getHours()).padStart(2, '0')
  const minutes = String(now.getMinutes()).padStart(2, '0')
  const seconds = String(now.getSeconds()).padStart(2, '0')

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.000Z`
}

/**
     *  V 0.2.0 - 2025-11-11
     *    - Modified'fontFamily' because I was gertting bad font displays
     *      on mobile devices.
     *
     *  V 0.1.0 - ] s
     */
class SpeedGmapControl {
  constructor (controlDiv, map) {
    const controlUI = document.createElement('div')
    controlUI.style.backgroundColor = '#fff'
    controlUI.style.border = '2px solid #fff'
    controlUI.style.borderRadius = '1px'
    controlUI.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)'
    controlUI.style.cursor = 'pointer'
    controlUI.style.marginBottom = '12px'
    controlUI.style.textAlign = 'center'
    controlUI.title = 'Click to recenter the map'
    controlDiv.appendChild(controlUI)

    const controlText = document.createElement('div')
    controlText.style.color = 'rgb(25,25,25)'
    controlText.style.fontFamily = 'Roboto,Arial,sans-serif' //
    // controlText.style.fontFamily = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif'
    controlText.style.fontSize = '14px'
    controlText.style.lineHeight = '22px' // change this to reduce box size
    controlText.style.paddingLeft = '5px'
    controlText.style.paddingRight = '5px'
    controlText.innerHTML =
        'Speed: <span id="idSpeed"></span> Trip - Time - Distance <span id="idTime"></span>'
    controlUI.appendChild(controlText)
    this.GmapControlOutput = controlText
  }
}

// Haversine-based "destination point" given distance & bearing
function destinationPoint (lat, lon, distanceMeters, bearingDegrees) {
  const R = 6371000 // Earth radius in meters
  const δ = distanceMeters / R // angular distance
  const θ = bearingDegrees * Math.PI / 180 // bearing in radians

  const φ1 = lat * Math.PI / 180
  const λ1 = lon * Math.PI / 180

  const φ2 = Math.asin(
    Math.sin(φ1) * Math.cos(δ) +
      Math.cos(φ1) * Math.sin(δ) * Math.cos(θ)
  )

  const λ2 = λ1 + Math.atan2(
    Math.sin(θ) * Math.sin(δ) * Math.cos(φ1),
    Math.cos(δ) - Math.sin(φ1) * Math.sin(φ2)
  )

  return {
    lat: φ2 * 180 / Math.PI,
    lon: (λ2 * 180 / Math.PI + 540) % 360 - 180 // normalize to -180..180
  }
}

function createCircleWalker (centerLat, centerLon, radiusKm = 5, stepDegrees = 7.5) {
  let angle = 0

  return function getNextPoint () {
    const point = destinationPoint(centerLat, centerLon, radiusKm * 1000, angle)
    const result = {
      lat: point.lat,
      lng: point.lon,
      angleDeg: Math.round(angle),
      step: Math.round(angle / stepDegrees) + 1
    }
    angle = (angle + stepDegrees) % 360
    return result
  }
}

var test_pos = {
  AccelerometerId: 0,
  CarBattery: null,
  CarBatteryAccel: null,
  DriverIDTagID: null,
  EventDate: getFormattedDateTime(),
  GpsDetails: null,
  ID: 0,
  IgnitionStatus: 1,
  Index: 0,
  Latitude: -25.9864,
  Longitude: 28.138,
  ObdDetails: null,
  OdoMeter: null,
  ReceivedDate: getFormattedDateTime(),
  Speed: 0.0,
  Tag: null,
  TripExtractedId: null,
  TripTypeID: null,
  UnitID: 359913060700110,
  ViolationID: 0

}

export default {
  data () {
    return {

      currentArrowRotationCaret: 0,
      // if we recieve the same co-ordinate multiple times there is no way to calculate
      // a direction, so use the previous direction
      keepDirection: false,

      getNext: {},

      prevLat: 0.0,
      prevLng: 0.0,
      TIME_AMBER_STATIONARY_HRS: 30,

      MOVING_TIME_REQ_INTERVAL: 7000,
      STOPPED_TIME_REQ_INTERVAL: 30000,
      timeRequestInterval: 7000,
      prevIgnitionStatus: null,

      output: {},
      selected: this.$store.state.tripButtons ?? [], // [], // can contain multiple values

      items: [
        { title: 'Breadcrumbs', value: 'crumbs' },
        { title: 'Trip Buttons', value: 'trips' }
        /*
          { title: 'Trip Navigator', value: 'navigator' },
          { title: 'Trip Calendar', value: 'calendar' },
          { title: 'Trip List', value: 'list' }

      */ ],

      // 2026-02-09 -
      //   added so that should we wish we can display buttons for
      //   the vehicle
      tripButtons: this.$store.state.tripButtons ?? [], // false,

      vehicleId: -1,

      VehicleReg: '',
      UnitID: '',
      UnitModelId: 0,
      DriverName: '',

      markers: [], // store all markers so we can clean up if needed
      currentMarker: {},
      currentUp: {},

      isLoading: false,
      map: null,

      mapStyle: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '100vw',
        /// -----------------------------------------------------------
        /// 2025-03-18
        ///   - changed apple device from 90dvh &  93 dvh to 91dvh and 94dvh
        /// -----------------------------------------------------------
        height: this.isAppleDevice() ? '91dvh' : '94dvh'
      },

      testPos: test_pos,
      testCount: 1,

      timerId: null,
      //
      savedFirstPosition: false,
      breadCrumb: false,
      zoom: 15,

      //----------------------------------------------------------------------
      // Setting this to truw will provide or create dummy data for the
      // testing the operation of the page
      //----------------------------------------------------------------------
      test: false

    }
  },

  mounted () {
    if (this.test) {
      this.items.push({ title: 'Debug Stop plot', value: 'stop' })
    }

    this.VehicleReg = this.$route.params.VehicleReg

    if (typeof this.$route.params.UnitID !== 'undefined') {
      this.UnitID = this.$route.params.UnitID
    }
    else {
      this.UnitID = 'TEST_UNIT'
    }

    if (typeof this.$route.params.VehicleReg !== 'undefined') {
      this.VehicleReg = this.$route.params.VehicleReg
    } else {
      this.VehicleReg = 'TEST_REG'
    }

    if (typeof this.$route.params.Driver !== 'undefined') {
      this.DriverName = this.$route.params.Driver
    } else {
      this.DriverName = '-'
    }

    if (typeof this.$route.params.VehicleID !== 'undefined') {
      this.vehicleId = parseInt(this.$route.params.VehicleID)
      this.UnitModelId = 33
    } else {
      this.UnitModelId = 33
    }

    if (typeof this.$route.params.Lat !== 'undefined') {
      this.prevLat = this.$route.params.Lat
    } else {
      this.prevLat = -27.00
    }

    if (typeof this.$route.params.Lng !== 'undefined') {
      this.prevLng = this.$route.params.Lng
    } else {
      this.prevLng = 27.00
    }


    if (this.$debug || this.test) {
      console.log(`UnitID:  ${this.UnitID}`)
      console.log(`VehicleReg:  ${this.VehicleReg}`)
      console.log(`Driver:  ${this.Driver}`)
      console.log(`UnitModelId:  ${this.UnitModelId}`)
      console.log(`prevLat:  ${this.prevLat}`)
      console.log(`prevLng:  ${this.prevLng}`)
      console.log(`vehicleId:  ${this.vehicleId}`)
    }

    this.initMap()

    this.setupTimer()

    //  if (this.test) {
    //    this.getNext = createCircleWalker(test_pos.Latitude, test_pos.Longitude, 5)
    //    this.fetchData()
    //    this.timerId = setInterval(() => {
    //      this.fetchData()
    //    }, 3000)
    //  } else {
    //    this.fetchLive()
    //    this.timerId = setInterval(() => {
    //      this.fetchLive()
    //    }, this.timeRequestInterval)
    //  }
  },

  computed: {
    isCrumb () {
      return this.selected.includes('crumbs')
    },
    isTripButtons () {
      return this.selected.includes('trips')
    },
    isList () {
      return this.selected.includes('list')
    },
    isNavigator () {
      return this.selected.includes('navigator')
    },
    isCalendar () {
      return this.selected.includes('calendar')
    },
    isDebugStop () {
      return this.selected.includes('stop')
    }

  },

  watch: {
    selected (newValue, oldValue) {
      if (newValue.length !== oldValue.length) {
        this.$store.commit('setTripButtons', this.selected)
        if (!this.isCrumb) {
          this.markers.forEach((marker, index) => {
            marker.setMap(null)
          })
        }

        if (this.isTripButtons) {
          // Replot the last position except this time add the buttons to the
          // on click event,
          this.plotUnitPosV2(this.currentUp, this.UnitModelId)
          //
          // Added a timeout to wait for map to settle before showing the
          // menu
          setTimeout(() => {
            google.maps.event.trigger(this.currentMarker, 'gmp-click')
          }, 500)
        }

        if (this.test) {
          if (this.isDebugStop) {
            clearInterval(this.timerId)
          }
          else {
            if (this.test) {
              this.setupTimer()
            }
          }
        }
      }
    }
  },

  beforeDestroy () {
    clearInterval(this.timerId)
  },

  methods: {

    /// 2026-02-16 - I decided to hardcode the timer after playing with adjusting it, because
    ///   of the risks of somethign going wrong and a whole lot of applications making calls
    //    all the time because I do not currently have a denier on the server side. This woudl
    //    overload things
    setupTimer () {
      if (this.timerId !== null) {
        clearInterval(this.timerId)
      }

      if (this.test) {
        this.getNext = createCircleWalker(test_pos.Latitude, test_pos.Longitude, 5)
        this.fetchData()
        this.timerId = setInterval(() => {
          this.fetchData()
        }, 3000)
      } else {
        this.fetchLive()
        this.timerId = setInterval(() => {
          this.fetchLive()
        }, 37000) /// this.timeRequestInterval)
      }
    },

    toggle (value) {
      const i = this.selected.indexOf(value)
      i === -1 ? this.selected.push(value) : this.selected.splice(i, 1)
    },



    initMap () {
      this.map = new google.maps.Map(document.getElementById('map'), {
        zoom: 12,
        center: { lat: -26, lng: 27 },
        mapTypeId: 'roadmap',
        mapId: 'b00531e667bdc68a'
        // mapTypeControl: false, // Disables the Satellite button
        // streetViewControl: false // This disables the Pegman control

      })

      var centerControlDiv = document.createElement('div')
      var centerControl = new SpeedGmapControl(centerControlDiv, this.map)
      centerControlDiv.index = 1

      this.output = centerControl.GmapControlOutput

      this.map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(
        centerControlDiv
      )
    },


    isAppleDevice () {
      const userAgent = window.navigator.userAgent
      const platform = window.navigator.platform

      const iosPlatforms = ['iPhone', 'iPad', 'iPod']
      const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']

      var isApple = false
      var os = ''

      if (iosPlatforms.indexOf(platform) !== -1) {
        isApple = true
        os = 'iOS'
      } else if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'macOS'
        isApple = true
      } else {
        os = 'Unknown OS'
        isApple = false
      }

      this.$debug ? console.log(`isAppleDevice() ${isApple} = ${os} `) : null

      return isApple
    },

    fetchData () {
      this.isLoading = true
      // debugger
      this.$axios
        .get('/api/vehicle.json') // Adjust the path based on your setup
        .then((response) => {
          this.error = null
          this.isLoading = false

          const nextCoOrd = this.getNext()
          this.testPos.Latitude = nextCoOrd.lat
          this.testPos.Longitude = nextCoOrd.lng

          if (this.testCount % 5 === 0) {
            this.testPos.Speed = 0
            this.testPos.IgnitionStatus = 0
          }
          else {
            this.testPos.Speed = Math.floor(Math.random() * 120) // Random speed between 0 and 120 km/h
            this.testPos.IgnitionStatus = 1
          }

          const result = formatISO(addSeconds(parseISO(this.testPos.EventDate), 3))

          this.testPos.EventDate = result

          this.plotUnitPosV2(this.testPos, 33)

          this.testCount = this.testCount + 1
        })
        .catch((err) => {
          this.isLoading = false
          this.error = 'Error fetching data: ' + err.message
          this.data = null
        })
    },


    createCircleWalker (centerLat, centerLon, radiusKm = 5, stepDegrees = 22.5) {
      let angle = 0

      return function getNextPoint () {
        const point = destinationPoint(centerLat, centerLon, radiusKm * 1000, angle)
        const result = {
          lat: point.lat,
          lng: point.lon,
          angleDeg: Math.round(angle),
          step: Math.round(angle / stepDegrees) + 1
        }
        angle = (angle + stepDegrees) % 360
        return result
      }
    },

    getBearing (from, to) {
      const toRad = deg => deg * Math.PI / 180
      const toDeg = rad => rad * 180 / Math.PI

      const lat1 = toRad(from.lat)
      const lat2 = toRad(to.lat)
      const dLng = toRad(to.lng - from.lng)

      const y = Math.sin(dLng) * Math.cos(lat2)
      const x =
          Math.cos(lat1) * Math.sin(lat2) -
          Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLng)

      const brng = toDeg(Math.atan2(y, x))
      return (brng + 360) % 360
    },


    fetchLive () {
      this.isLoading = true
      let url = this.$baseUrl
      url += `/api/v2/unit-position/${this.UnitID}`

      if (this.$debug) {
        console.log(url)
      }

      this.$axios
        .get(url)
        .then((response) => {
          this.isLoading = false

          this.$debug ? console.log(`${response.data.Latitude}  ${response.data.Longitude} ${response.data.EventDate} `) : null

          this.plotUnitPosV2(response.data, 33)
        })
        .catch((e) => {
          this.isLoading = false
          console.log('Error')
          console.log(e)
        })
    }, // end fetchLive()


    /**
         *  V 0.1.0 - 2023-02-28
         *     - MOdified original as it was failing wiht val of undefined,
         *       the val need to be prefxied with typeof
         *
         * @param {*} val
         * @param {*} type
         */
    // eslint-disable-next-line class-methods-use-this
    checkNull (val, type) {
      //
      switch (type) {
      case 'txt':
        if (typeof val === 'undefined') return ''
        return val
      case 'date':
        if (typeof val === 'undefined') {
          /*  */
          return '1970/01/01 00:00:01'
        }
        return val.toLocaleString()

      case 'dd':
        if (val == null) {
          return 0.0
        }
        return val

      case 'i':
        if (typeof val === 'undefined') return -1
        return val
      default:
        if (typeof val === 'undefined') return null
        return val
      }
    },

    /**
         *   V 0.1.0 - 2022-10-03
         *
         */
    getElapsed (lastUpdate) {
      const lastTime = new Date(lastUpdate)
      const currTime = new Date()
      const elapsed = differenceInHours(currTime, lastTime)
      if (elapsed > this.TIME_AMBER_STATIONARY_HRS) {
        return true // this.TIME_AMBER_STATIONARY_HRS;
      }

      return false
    },


    CheckForAmber (IgnStatus, LastUpdateTime) {
      switch (IgnStatus) {
      // off
      case 0:
        return this.getElapsed(LastUpdateTime)
        // on
      case 1:
        return this.getElapsed(LastUpdateTime)
        //
      default:
        break
      }
      return true
    },

    /**
       * {
      "AccelerometerId": 0,
      "CarBattery": null,
      "CarBatteryAccel": null,
      "DriverIDTagID": null,
      "EventDate": "2026-02-11T16:36:41.000Z",
      "GpsDetails": null,
      "ID": 0,
      "IgnitionStatus": 1,
      "Index": 0,
      "Latitude": -27.95618,
      "Longitude": 22.827544,
      "ObdDetails": null,
      "OdoMeter": null,
      "ReceivedDate": "0001-01-01T00:00:00",
      "Speed": 82.0,
      "Tag": null,
      "TripExtractedId": null,
      "TripTypeID": null,
      "UnitID": "359913060700110",
      "ViolationID": 0
  }
       */

    updateSpeed (display, disconnected) {
      if (disconnected) {
        this.output.style.backgroundColor = 'rgb(223 105 20 / 91%)'
        this.output.style.color = '#000000' // white
        this.output.innerHTML = '&nbsp;&nbsp;' + display + '&nbsp;&nbsp;'
      }
      else {
        this.output.style.backgroundColor = '#fff400e8'
        this.output.style.color = '#000000' // white
        this.output.innerHTML = '&nbsp;&nbsp;' + display + '&nbsp;&nbsp;'
      }
    },


    plotUnitPosV2 (up, modelId) {
      // debugger;
      this.currentUp = up

      let disconnected = false

      if (up === '') {
        up = {
          VehicleReg: this.VehicleReg,
          DriverName: this.DriverName,
          Speed: 0.0,
          IgnitionStatus: 0,
          EventDate: getFormattedDateTime()
        }
        disconnected = true
      }

      up.VehicleReg = this.VehicleReg
      up.DriverName = this.DriverName
      up.prevLat = this.prevLat
      up.prevLng = this.prevLng


      if (typeof this.map.getZoom() !== 'undefined') {
        this.zoom = this.map.getZoom()
      }

      if (this.prevIgnitionStatus === null) {
        this.prevIgnitionStatus = up.IgnitionStatus
      }

      // if ((up.IgnitionStatus === 0) && (this.prevIgnitionStatus === 1)) {
      //   this.timeRequestInterval = this.STOPPED_TIME_REQ_INTERVAL
      //
      // }
      // else {
      //   this.timeRequestInterval = this.MOVING_TIME_REQ_INTERVAL
      //
      // }

      let display = ''

      if (disconnected) {
        display = `  ${up.VehicleReg} ( has no signal!!! ) </br> Driver:  ${up.DriverName} </br> Speed: ${up.Speed} km/h
         Time: ${up.EventDate.replace('T', '  ').split('+')[0]}`
        this.updateSpeed(display, disconnected)
        return
      }
      else {
        display = `${up.VehicleReg} </br> Driver:  ${up.DriverName} </br> Speed: ${up.Speed} km/h
         Time: ${up.EventDate.replace('T', '  ').split('.')[0]}`
        this.updateSpeed(display, disconnected)
      }

      const veh = this.buildMovingContent(up)

      this.prevLat = up.Latitude
      this.prevLng = up.Longitude

      const advancedMarkerElement = new google.maps.marker.AdvancedMarkerElement({
        map: this.map,
        content: veh,
        position: { lat: up.Latitude, lng: up.Longitude },
        title: this.VehicleReg
      })

      advancedMarkerElement.addListener('gmp-click', () => {
        setTimeout(() => {
          this.togglehighlight(advancedMarkerElement, veh)
        }, 300)

        // this.togglehighlight(advancedMarkerElement, up)
      })

      // remove all markers before adding new one
      if (!this.isCrumb) {
        this.markers.forEach((marker, index) => {
          marker.setMap(null)
        })
      }

      this.currentMarker = advancedMarkerElement

      this.markers.push(advancedMarkerElement)

      this.$debug ? console.log(`${getFormattedDateTime()} - Marker added at ${up.Latitude}, ${up.Longitude} - ${up.IgnitionStatus} - ${this.testCount}`) : null

      this.zoomCoOrdinatesV2()
    },


    zoomCoOrdinatesV2 () {
      const bounds = new google.maps.LatLngBounds()

      var lat = this.checkNull(this.currentMarker.position.lat, 'dd')
      var lon = this.checkNull(this.currentMarker.position.lng, 'dd')

      if ((lat === 0) || (lon === 0)) {
        console.log(`No posisiton for Marker #${index + 1}`)
        console.log(`lat: ${lat} Lon: ${lon}`)
        return
      }
      var pos = new google.maps.LatLng(this.currentMarker.position)

      bounds.extend(pos)

      this.map.fitBounds(bounds)
      this.map.setZoom(this.zoom)
    },

    togglehighlight (markerView, property) {
      if (markerView.content.classList.contains('highlight-veh-marker-2026')) {
        markerView.content.classList.remove('highlight-veh-marker-2026')
        markerView.zIndex = null
      }
      else {
        markerView.content.classList.add('highlight-veh-marker-2026')
        markerView.zIndex = 1
      }
    },

    buildMovingContent (veh) {
      const directionIcon = 'angle-right' // 'caret-down'
      const stopIcon = 'stop'

      if ((veh.prevLat !== veh.Latitude) && (veh.prevLng !== veh.Longitude)) {
        this.currentArrowRotationCaret = this.getBearing(
          { lat: veh.prevLat, lng: veh.prevLng },
          { lat: veh.Latitude, lng: veh.Longitude }
        ) - 90
      }

      const arrowRotationCaret = this.currentArrowRotationCaret

      const unitID = veh.UnitID
      const regNumber = veh.VehicleReg
      // const vehicleId = veh.vehicleId
      const vehicleId = this.vehicleId

      const lat = veh.Latitude
      const lng = veh.Longitude

      const lastUpdate = this.checkNull(veh.EventDate, 'date').replace('T', '  ').split('.')[0]
      const infoSpeed = this.checkNull(veh.Speed, 'i')
      const driverName = veh.DriverName
      const driverName2 = 'Driver: ' + this.checkNull(veh.DriverName, 'txt').replace('/', '  ')

      const vehCurrent = `Speed: ${infoSpeed} km/h  </br> Time: ${lastUpdate}`

      const vehicleDetails = `  (${veh.UserVehicleColour}) ${veh.UserVehicleMake} - ${veh.UserVehicleModel}`

      const content = document.createElement('div')
      content.classList.add('track-veh-marker-2026-follow')

      let iconType = veh.IgnitionStatus === 0 ? stopIcon : directionIcon

      let elapsed = false
      if (this.getElapsed(veh.LastUpdate)) {
        iconType = 'wifi'
        elapsed = true
      }

      if (this.isTripButtons) {
        this.tripButtons = true
      } else {
        this.tripButtons = false
      }


      if (elapsed) {
        content.innerHTML = `
            <span class="icon ">
                <i aria-hidden="true" class="fas fa-${iconType} fa-stack-1x" ></i>
                <i aria-hidden="true" class="fas fa-slash fa-stack-1x" style="color: red;  "></i>
            </span>
        `
      }
      else {
        if (veh.IgnitionStatus === 0) {
          content.innerHTML = `
          <div class="icon">
              <i aria-hidden="true" class="fas fa-icon fa-${iconType}" style="font-size: 20px !important; " ></i>
              <!-- Below creates a hidden piece of text that is only readable by screen readers-->
              <span class="fa-sr-only">${iconType}</span>
          </div>
          `
        }
        else {
          content.innerHTML = `
          <div class="icon">
              <i aria-hidden="true" class="fas fa-icon fa-${iconType}" style="font-size: 30px !important; transform: rotate(${arrowRotationCaret}deg); " ></i>
              <!-- Below creates a hidden piece of text that is only readable by screen readers-->
              <span class="fa-sr-only">${iconType}</span>
          </div>
          `
        }
      }


      const tripButtonsHtml = `
           <div  class="buttonColumn">

                    <span class="fa-stack">
                        <i class="fas fa-route fa-stack-1x"></i>

                    </span>
                    <a class="infoButton " href=" #/trip-list/${unitID}/${regNumber}/${driverName}/${vehicleId}">
                        <i class="fas fa-timeline "></i>
                        &nbsp;&nbsp;&nbsp;Trips&nbsp;&nbsp;&nbsp;
                    </a>

                    <a class="infoButton " href=" #/calendar-trips-select/${unitID}/${regNumber}/${driverName}/${vehicleId}">
                        <i class="mdi mdi-calendar-expand-horizontal "></i>
                        Calendar
                    </a>

                    <a class="infoButton " href=" #/day-navigator/${unitID}/${regNumber}/${driverName}/${vehicleId}">
                        <i class="mdi mdi-road-variant theme--light "></i>
                        Navigator
                    </a>
            </div>

      `

      const trackButtonHtmlOld = `
                        <div>
                            <a class="infoButton " href=" #/map-follow/${unitID}/${regNumber}/${driverName}/${vehicleId}">
                                <i class="fa-solid fa-location-crosshairs"></i>
                                &nbsp;&nbsp;Follow&nbsp;&nbsp;
                            </a>
                        </div>
                <div>
                    <a class="infoButton "
                        href=" #/map-follow/${unitID}/${regNumber}/${driverName}/${vehicleId}/${lat}/${lng}">
                        <i class="fa-solid fa-location-crosshairs"></i>
                        &nbsp;&nbsp;Follow&nbsp;&nbsp;
                    </a>
                </div>

       `


      const trackButtonHtml = `

                <div>
                    <a class="infoButton "
                        href=" #/map-follow/${unitID}/${regNumber}/${driverName}/${vehicleId}/${lat}/${lng}">
                        <i class="fa-solid fa-location-crosshairs"></i>
                        &nbsp;&nbsp;Follow&nbsp;&nbsp;
                    </a>
                </div>

       `


      content.innerHTML += `
            <div class="details" >

                <div class="price">${regNumber}</div>
               <!-- <div class="address">${vehicleDetails} </div> -->
                <div class="address">${driverName} </div>
                <div class="address">${vehCurrent} </div>
                <div class="features">
                  ${trackButtonHtml }
                    <div>

                        ${this.tripButtons ? tripButtonsHtml : ''}

                    </div>

            </div>
    `
      return content
    }

  }

}

</script>

<style>
   /* Center the progress circular over the map */
   .progress-overlay {
     display: none !important; /* Hidden by default */
     position: absolute;
     top: 50% !important;
     left: 50% !important;
     transform: translate(-50%, -50%);
     z-index: 10; /* Ensure it’s above the map */
   }

   /**
   *   2023-03-13: Added so that button on google infoMap looked better
   */

   .buttonColumn {
     display: flex;
     flex-direction: column;
     gap: 10px;
   }

   .infoButton {
     background-color: #1976d2;
     display: inline-block;
     text-decoration: none;
     color: #fff !important;
     /* color: inherit; */
     padding: 0.5rem 1rem;
     border-radius: 4px;
     transition: all 0.3s;
   }

     .infoButton:hover {
       background-color: #2196f3;
       /* background-color: #1976d2; */
       color: #fff;
     }


   :root {
     --building-color: #ff9800;
     --house-color: #0288d1;
     --shop-color: #7b1fa2;
     --warehouse-color: #558b2f;
     /* */
     --car-side-color: #f40505;
     --car-color: #0288d1;
     --wifi-color: #ff9c09;
   }

   .marker-content {
     display: flex;
     flex-direction: column;
     gap: 6px;
     padding: 8px;
     background: white;
     border-radius: 8px;
     box-shadow: 0 2px 6px rgba(0,0,0,0.3);
   }


   /*
    * track-veh-marker-2026-follow styles in unhighlight-veh-marker-2026ed state.
    */
   .track-veh-marker-2026-follow {
     /* top: -9px; */
     align-items: center;
     background-color: #ffffff;
     border-radius: 50%;
     color: #263238;
     display: flex;
     font-size: 22px !important;
     gap: 15px;
     height: 30px;
     justify-content: center;
     padding: 4px;
     position: relative;
     position: relative;
     transition: all 0.3s ease-out;
     width: 30px;
     transform: translateY(-9px);
   }

     /*       .track-veh-marker-2026-follow::after {
         border-left: 9px solid transparent;
         border-right: 9px solid transparent;
         border-top: 9px solid #ffffff;
         content: '';
         height: 0;
         left: 50%;
         position: absolute;
         top: 95%;
         transform: translate(-50%, 0);
         transition: all 0.3s ease-out;
         width: 0;
         z-index: 1;
       }
  */

     .track-veh-marker-2026-follow .icon {
       align-items: center;
       display: flex;
       justify-content: center;
       color: #ffffff;
     }


       .track-veh-marker-2026-follow .icon svg {
         height: 30px;
         width: auto;
       }

     /*
     2026-01-27  below was very important in getting correct operations
   */
     .track-veh-marker-2026-follow .details {
       display: none; /* making this none was mui importante because otherwise the deatils appeared on map without click */
       flex-direction: column;
       flex: 1;
       align-items: center;
     }

     .track-veh-marker-2026-follow .registration {
       color: #9e9e9e;
       font-size: 10px;
       margin-bottom: 10px;
       margin-top: 5px;
     }


     .track-veh-marker-2026-follow .address {
       color: #9e9e9e;
       font-size: 12px;
       margin-bottom: 2px;
       margin-top: 2px;
       align-items: center;
     }

     .track-veh-marker-2026-follow .features {
       align-items: flex-end;
       display: flex;
       flex-direction: column !important;
       gap: 10px;
     }

       .track-veh-marker-2026-follow .features > div {
         display: flex;
         flex-direction: column !important;
         ;
         /* */

         align-items: center;
         background: #f5f5f5;
         border-radius: 5px;
         border: 1px solid #ccc;
         display: flex;
         font-size: 10px;
         gap: 5px;
         padding: 5px;
       }

     /*
    * track-veh-marker-2026-follow styles in highlight-veh-marker-2026ed state.
    */
     .track-veh-marker-2026-follow.highlight-veh-marker-2026 {
       display: flex;
       display: inline-table;
       /* */

       background-color: #ffffff;
       border-radius: 8px;
       box-shadow: 10px 10px 5px rgba(0, 0, 0, 0.2);
       height: 80px;
       padding: 8px 15px;
       width: auto;
     }

       /*         .track-veh-marker-2026-follow.highlight-veh-marker-2026::after {
           display: flex;
           display: inline-table;
           border-top: 9px solid #ffffff;
         }
  */

       .track-veh-marker-2026-follow.highlight-veh-marker-2026 .details {
         display: flex;
       }

       .track-veh-marker-2026-follow.highlight-veh-marker-2026 .icon svg {
         width: 50px;
         height: 50px;
       }


     .track-veh-marker-2026-follow .size {
       color: #388e3c;
     }



     /*
    * Vechicle Moving icon colors.
    */
     .track-veh-marker-2026-follow.highlight-veh-marker-2026:has(.fa-wifi) .icon {
       color: var(--wifi-color);
     }

     .track-veh-marker-2026-follow:not(.highlight-veh-marker-2026):has(.fa-wifi) {
       background-color: var(--wifi-color);
     }

       .track-veh-marker-2026-follow:not(.highlight-veh-marker-2026):has(.fa-wifi)::after {
         border-top: 9px solid var(--wifi-color);
       }




     /*
    * Vechicle Moving icon colors.
    * -----------------------------------------------------
    */
     .track-veh-marker-2026-follow.highlight-veh-marker-2026:has(.fa-caret-down) .icon {
       color: var(--car-side-color);
     }

     .track-veh-marker-2026-follow:not(.highlight-veh-marker-2026):has(.fa-caret-down) {
       background-color: var(--car-side-color);
     }

       .track-veh-marker-2026-follow:not(.highlight-veh-marker-2026):has(.fa-caret-down)::after {
         border-top: 9px solid var(--car-side-color);
       }

     /*
    * Vechicle Moving icon colors.
    * -----------------------------------------------------
    */
     .track-veh-marker-2026-follow.highlight-veh-marker-2026:has(.fa-angle-down) .icon {
       color: var(--car-side-color);
     }

     .track-veh-marker-2026-follow:not(.highlight-veh-marker-2026):has(.fa-angle-down) {
       background-color: var(--car-side-color);
     }

       .track-veh-marker-2026-follow:not(.highlight-veh-marker-2026):has(.fa-angle-down)::after {
         border-top: 9px solid var(--car-side-color);
       }


     /*
    * Vechicle Moving icon colors.
    * -----------------------------------------------------
    */
     .track-veh-marker-2026-follow.highlight-veh-marker-2026:has(.fa-angle-right) .icon {
       color: var(--car-side-color);
     }

     .track-veh-marker-2026-follow:not(.highlight-veh-marker-2026):has(.fa-angle-right) {
       background-color: var(--car-side-color);
     }

       .track-veh-marker-2026-follow:not(.highlight-veh-marker-2026):has(.fa-angle-right)::after {
         border-top: 9px solid var(--car-side-color);
       }



     /*
    * Car Colours .
    */
     .track-veh-marker-2026-follow.highlight-veh-marker-2026:has(.fa-stop) .icon {
       color: var(--car-color);
     }

     .track-veh-marker-2026-follow:not(.highlight-veh-marker-2026):has(.fa-stop) {
       background-color: var(--car-color);
     }

       .track-veh-marker-2026-follow:not(.highlight-veh-marker-2026):has(.fa-stop)::after {
         border-top: 9px solid var(--car-color);
       }
</style>
